import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import React from 'react';

const LoadingButton = ({ isLoading, disabled, color, children, icon, iconButton, className, sx, ...rest }) => {
  const UseButton = iconButton ? IconButton : Button;
  const col = color === 'danger' ? 'error' : color || 'inherit';
  return (
    <Box
      sx={[
        {
          position: 'relative',
          display: 'inline-block',
        },
        rest.fullWidth ? { width: '100%' } : null,
      ]}
    >
      <UseButton disabled={isLoading || disabled} sx={sx} color={col} {...rest}>
        {icon && <Box component="span" sx={{ display: 'flex', mr: 1 }} children={icon} />}
        {children}
      </UseButton>
      {isLoading && (
        <CircularProgress
          size={24}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
          color={color === 'primary' ? 'primary' : 'inherit'}
        />
      )}
    </Box>
  );
};

export default LoadingButton;
